import { FETCH_BATTERY_TABLE } from "../../actions/types";

const INITIAL_STATE = {
  results: [
    {
      soc: 0,
      p: 0,
      status: 0
    }
  ]
};

const batteryTableReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_BATTERY_TABLE:
      return action.payload.data;
    default:
      return state;
  }
};

export default batteryTableReducer;



// WEBPACK FOOTER //
// ./src/reducers/helpers/table_battery_reducer.js